import React from 'react';
import ResTable from './ResTable.jsx';
import ResOrcTable from './ResOrcTable.jsx';

class ResumoAnualVis extends React.Component {

    constructor() {

        super();

        this.state = {
            resOrc: false
        };

        this.resumo = this.resumo.bind(this);
        this.resOrc = this.resOrc.bind(this);

    }

    resumo() {
        this.setState({ resOrc: false });
    }

    resOrc() {
        this.setState({ resOrc: true });
    }

    render() {
        return(
            <div>
                <p Class={ "resumo-anual-lbl" }>
                    <b>Centro:</b> { this.props.centroNome }
                </p><br />
                <p Class={ "resumo-anual-lbl" }>
                    <b>Ano:</b> { this.props.ano }
                </p><br />
                <button type="button" id="resumo-anual-voltar2-btn" onClick={ this.props.voltar2 }>
                    Voltar
                </button><br />
                <button type="button"
                    id="resumo-anual-resumo-btn"
                    Class={ "resumo-anual-resumo-btn-" + this.state.resOrc }
                    onClick={ this.resumo }>Resumo</button>
                <button type="button"
                    id="resumo-anual-resorc-btn"
                    Class={ "resumo-anual-resorc-btn-" + this.state.resOrc }
                    onClick={ this.resOrc }>Resumo x Orçamento</button>
                <br />
                { this.state.resOrc === false &&
                    <ResTable resumoAnual={ this.props.resumoAnual } /> }
                { this.state.resOrc === true &&
                    <ResOrcTable resumoAnual={ this.props.resumoAnual } /> }
            </div>
        );
    }

}

export default ResumoAnualVis;

